module.exports = __webpack_public_path__ + "img/4b6a8789aeb276343e6841ad32901372.jpg";